const persistStore = {
    state: {
        coverHidden: false,
        adminToken: ''
    },
    mutations: {
        coverHidden: (state: any, payload: boolean) => state.coverHidden = payload,
        adminToken: (s: any, v: string) => s.adminToken = v,
    },
    getters: {
        coverHidden: (state: any) => state.coverHidden,
        adminToken: (s: any) => s.adminToken,
        isAdminAuthenticated: (s: any) => !!s.adminToken,
    }
}

export default persistStore